"use client";
import React, {createContext, useContext} from 'react';
import {SearchBaseStore} from "./SearchBaseStore";
import {ConfirmStore} from "./ConfirmStore";
import {ModalStore} from "./ModalStore.jsx";
import {FloatAreaStore} from "./homepage/FloatAreaStore";
import {NavigationStore} from "./homepage/NavigationStore";
import {ContentStore} from "./homepage/ContentStore";
import {MenuStore} from "./admin/MenuStore"
import {BoardDetailStore} from "./admin/BoardDetailStore"
import {TemplateStore} from "./admin/TemplateStore"
import {UserStore} from "./admin/UserStore"
import {BannerStore} from "./admin/BannerStore"
import {PopupManageStore} from "./admin/PopupManageStore"
import {LoadingStore} from "./LoadingStore.jsx";



let store;


const StoreContext = createContext(undefined);

export class Store {
    searchBaseStore;
    confirmStore;
    modalStore;
    floatAreaStore;
    navigationStore;
    contentStore;
    menuStore;
    boardDetailStore;
    templateStore;
    userStore;
    bannerStore;
    popupManageStore;

    constructor(initialState) {
        this.searchBaseStore = new SearchBaseStore(this);
        this.confirmStore = new ConfirmStore(this);
        this.modalStore = new ModalStore(this);
        this.floatAreaStore = new FloatAreaStore(this);
        this.navigationStore = new NavigationStore(this, initialState?.navigation);
        this.contentStore = new ContentStore(this);
        this.menuStore = new MenuStore(this, initialState?.navigation);
        this.boardDetailStore = new BoardDetailStore(this);
        this.templateStore  = new TemplateStore(this);
        this.userStore = new UserStore(this);
        this.bannerStore = new BannerStore(this);
        this.popupManageStore = new PopupManageStore(this);
        this.loadingStore = new LoadingStore(this);
    }
}

export const StoreProvider = ({children, initialState}) => {
    if (!store) {
        store = new Store(initialState);
    }

    return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}

export const useStore = () => {
    const context = useContext(StoreContext);
    if (!context) throw new Error('useStore must be used inside of StoreProvider');

    return context;
}

export const getStore = () => {
    if (!store) throw new Error('Store has not been initialized');

    return store;
};

if (typeof window !== 'undefined') {
    window.getStore = getStore;
}
